module.exports = "/_next/static/images/icon2-fb724daac00cc90e85d67c6ae9aecc89.png";